import { AUTH_METHOD, type AuthMethod } from "../constants/authMethods"
import { getEnv } from "../utils/getEnv"
import type { PublicConfig } from "./config.types"
import { getEnvironment } from "./getEnvironment"

export function getPublicConfig(): PublicConfig {
  const environment = getEnvironment(window.location.href)
  const isProduction = environment === "production"
  const isDevelopment = environment === "development" || environment === "local"

  return {
    cmApiBaseUrl: getEnv("VITE_CM_API_BASE_URL", "https://localhost:7021"),
    auth: {
      defaultMethod: getEnv<AuthMethod>("VITE_AUTH_DEFAULT_METHOD", AUTH_METHOD.COOKIE),
      msalApiScope: getEnv("VITE_MSAL_API_SCOPE", "")
    },
    environment,
    sentryDsn: getEnv("VITE_SENTRY_DSN", ""),
    features: {
      showPlaceholderContent: !isProduction,
      enableEditParent: isDevelopment,
      enablePPProvisioning: !isProduction
    }
  }
}
